module.exports = __webpack_public_path__ + "static/media/responsive-img.1dd00fc2.svg";